
import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import { CalendarIcon } from "app/components/Icons";
import IconText from "app/components/IconText";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../containers/Tickets/redux/slice";
import CustomTooltip from "app/components/Tooltip";
import { format } from "date-fns/format";

export const CalendarButton=()=> {
  const dispatch = useDispatch();  
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const handleChange = (val) => {
    dispatch(actions.setTicketFormValue({name: 'dueDate',value: val.toISOString()}));
    setSelectedDate(val);
  };
  return (
    <>
    <AdaptiveDatePicker 
        trigger={
          <button className="flex flex-row items-center justify-center h-[28px] min-w-[28px] rounded-[4px] border border-[#E9ECF2] hover:bg-[#ECEEF2] hover:text-[#79808A] hover:border-[#E9ECF2] transition-all duration-200">
             <CustomTooltip text="Set due date"  position="bottom"> 
              <span className="flex items-center gap-1">
              <CalendarIcon />
                {selectedDate && (
              <div className="flex items-center gap-1">
                <span className="text-xs leading-[18px] font-medium text-secondary">
                  {format(selectedDate, "dd MMM, yyyy")}
                </span>
              </div>
            )}
              </span>
              
             </CustomTooltip>   
              </button>
        }
        className="!h-[42px] border-t-0 rounded-none"
          value={selectedDate}
          onChange={(v) => {
            handleChange(v);
          }}
          isDisablePastDate={true}
          dateInfoIcon={
            <div className="flex items-center gap-2 pl-4 pr-2 py-2 text-secondary text-sm font-semibold uppercase border-b border-[#E9ECF2]">
                DUE DATE
            </div>
        }
        />
    </>
  );
};